export const AD_MIRRORING_TITLE_AVAILABLE = 'Platform Selection';
export const AD_MIRRORING_TITLE_NOT_AVAILABLE =
  'Platform Selection (Not Available)';
export const AD_MIRRORING_DISABLED =
  'Platform Selection is not available on your chosen demographic:';
export const AD_MIRRORING_DESCRIPTION =
  'Mirror linear schedule on simulcast stations.';
